import {RecommendationProcessModel} from "../../models/recommendation.model";

export function getRecommendationProcessAgentId(process: RecommendationProcessModel): string {
  if (process.agentId) {
    return process.agentId
  }

  const elements = process.processId.split('_');

  if (elements.length >= 3) {
    return elements[2];
  }

  return process.id;
}
